<script	setup>
import Modal from '@/Pages/sharedComponents/modal.vue';

const props = defineProps({
	accessibilityMonths0: Number,
    areaString: {
        type: String,
        default: "area3relations" // retrocompatibility. DUMB
    }
})
const id = 'modelIsNotAccessible'
</script>

<template>
	<Modal :id="id">
		<article>
			{{$tg(areaString+'.modalNotAccessible')}} <b>{{accessibilityMonths0}} {{$tg('months')}}</b>
		</article>

		<div class="btn w-2/3 mt-8 bg-white text-blue"
			data-micromodal-close aria-label="Close modal">
			{{ $tg('continue')}}
		</div>
	</Modal>
</template>
